const userEn = {
	userTable: 'Hozzáférés',
	name: 'Név',
	roles: 'Jogkör',
	email: 'E-mail',
	registrationTimestamp: 'Regisztráció ideje',
	lastLoginTimestamp: 'Utolsó belépés ideje',
	registrationStatus: 'Enabled',
	dashboardRoleTable: 'Jogkör',
	title: 'Név',
	adminDescription: 'Leírás',
	isEnabled: 'Enabled',
	created: 'Létrehozva',
	updated: 'Módosítva',
	dashboardRoleEditForm: 'Jogkör',
	basic: 'Alapadatok',
	servicePermissionList: 'Szolgáltatások',
	contentPermissionList: 'Tartalom hozzáférés',
	key: 'Rendszer által használt név (opcionális)',
	orderIndex: 'Pozíció',
	isSuperAdmin: 'Szuperadmin',
	service: 'Szolgáltatás',
	grantedLevel: 'Jogosultság',
	contentType: 'Tartalomtípus',
	userGroups: 'User Groups'
};

export default userEn;
